export const normalizeDiscountAllowedRoles = (value) => {
  const normalized = String(value || 'all').trim().toLowerCase();
  return ['all', 'dispatcher', 'admin'].includes(normalized) ? normalized : 'all';
};

export const parseDiscountSnapshot = (value) => {
  if (!value) return null;
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const canCurrentUserApplyDiscount = (discount, userType) => {
  const allowedRoles = normalizeDiscountAllowedRoles(discount?.allowed_roles);
  const normalizedUserType = String(userType || '').trim().toLowerCase();

  if (allowedRoles === 'all') return ['user', 'dispatcher', 'admin', 'developer'].includes(normalizedUserType);
  if (allowedRoles === 'dispatcher') return ['dispatcher', 'admin', 'developer'].includes(normalizedUserType);
  if (allowedRoles === 'admin') return ['admin', 'developer'].includes(normalizedUserType);
  return false;
};

export const getDiscountRoleBlockedReason = (discount, userType) => {
  if (canCurrentUserApplyDiscount(discount, userType)) return null;
  return 'Эта скидка недоступна для вашей роли.';
};
